import { Alert } from 'antd'
import { Link } from 'react-router-dom'
import { advicePrepTrialLimitHint } from './trialLimit'

function formatTrialEnd(value: string | null) {
  if (!value) return null
  const parsed = new Date(value)
  return Number.isNaN(parsed.getTime()) ? null : parsed.toLocaleDateString()
}

type AdvicePrepTrialLimitAlertProps = {
  trialEnd: string | null
  noun?: string
}

/**
 * The reason the buttons are disabled. A tooltip alone would not do: it never
 * opens for a keyboard or touch user, leaving them a greyed-out control and no
 * explanation of what to do about it.
 */
export default function AdvicePrepTrialLimitAlert({
  trialEnd,
  noun = 'connections',
}: AdvicePrepTrialLimitAlertProps) {
  const endsOn = formatTrialEnd(trialEnd)

  return (
    <Alert
      type="info"
      showIcon
      message={`Adding ${noun} is turned off during your free trial`}
      description={
        <>
          {advicePrepTrialLimitHint}{' '}
          {endsOn
            ? `Adding turns back on when the trial ends on ${endsOn} and billing starts.`
            : 'Adding turns back on when the trial ends and billing starts.'}{' '}
          Connections you had before subscribing are not affected.{' '}
          <Link to="/billing">Manage your subscription</Link> to see your trial.
        </>
      }
    />
  )
}
